import { min } from 'lodash';
import React from 'react';
import FormField from './FormField';
import { Field, FieldRenderProps } from '@progress/kendo-react-form';
import { useParams } from 'react-router-dom';

const Fields: React.FC<FieldRenderProps> = (formRenderProps) => {
    const {
        id,
        disabled,
        valid,
        optional,
        validationMessage,
        formId,
        fields,
        form,
        ...others
    } = formRenderProps;

    let fieldWidth = form.Columns === 1 ? 'basis-full pl-1' : `basis-full p-1 md:basis-1/2 lg:basis-1/${min([3, form.Columns])} xl:basis-1/${form.Columns}  2xl:basis-1/${form.Columns}`
    let parentStyle = 'flex flex-wrap w-full ps-2 pr-2';
    if (form.Direction === 1) {
        parentStyle = `gap-0 columns-1 md:columns-2 lg:columns-${min([3, form.Columns])} xl:columns-${form.Columns}` //+ form.Columns;
        fieldWidth = 'inline-block w-full pl-1';
    }

    return (
        <div className={parentStyle}>
            {fields?.map((f) => {
                return (
                    f.Enabled &&
                    <div className={fieldWidth} key={f.ID}>
                        <Field
                            {...others}
                            id={`field_${f.ID}`}
                            name={`field_${f.ID}`}
                            component={FormField}
                            field={f}

                        />
                    </div>)
            })}
        </div>
    );
};

export default Fields;